module.exports = __webpack_public_path__ + "img/icon-payment-creditcard-blue.f885fdb8.png";